var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-app",attrs:{"id":"app","data-component":"mobile-app"}},[(!_vm.showCaseReadOnly)?_c('app-header'):_vm._e(),_c('notifications'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }